import { createSignal } from "solid-js";

const STORAGE_KEY = "vektor.featureFlags";

function readCache(): Record<string, boolean> {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return (parsed && typeof parsed === "object") ? parsed : {};
    } catch {
        return {};
    }
}

const [flags, setFlagsSignal] = createSignal<Record<string, boolean>>(readCache());

export const featureFlags = flags;

export function setFeatureFlags(next: Record<string, boolean> | null | undefined) {
    const sanitized: Record<string, boolean> = {};
    if (next && typeof next === "object") {
        for (const [k, v] of Object.entries(next)) {
            if (typeof v === "boolean") sanitized[k] = v;
        }
    }
    setFlagsSignal(sanitized);
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(sanitized));
    } catch {
        // localStorage may be unavailable (private mode); cache is best-effort
    }
}

export function clearFeatureFlags() {
    setFlagsSignal({});
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch {
        // ignore
    }
}

export function isFeatureEnabled(key: string): boolean {
    return flags()[key] === true;
}
